import React from 'react'
import Webcam from 'react-webcam'
import Header from 'components/headers/bulletins'
import usePhotoCapture from './hook/usePhotoCapture'
import { usePhotoUpload } from './hook/usePhotoUpload'

const PhotoCapture: React.FC = () => {
    const { webcamRef, photo, capturePhoto, retakePhoto } = usePhotoCapture()
    const { isUploading, error, uploadPhoto } = usePhotoUpload()

    const handleUpload = () => {
        uploadPhoto(photo)
    }
    return (
        <>
            <Header title="گرفتن عکس سلفی" />
            <div className="flex flex-col items-center p-4 mt-6 bg-white">
                <h1 className="text-xl mb-4">گرفتن عکس جهت احراز هویت</h1>
                {error && <p className="text-red-1 mb-4">{error}</p>}
                {!photo ? (
                    <>
                        <div className="flex justify-center items-center">
                            <div className="relative">
                                <Webcam
                                    audio={false}
                                    ref={webcamRef}
                                    screenshotFormat="image/png"
                                    width={250}
                                    height={350}
                                    videoConstraints={{
                                        facingMode: 'user',
                                    }}
                                    className="rounded-lg shadow-lg"
                                />
                                <div className="absolute flex justify-center items-center inset-0 pointer-events-none">
                                    <div className="w-36 h-48 border-4 border-red-3 rounded-full opacity-75"></div>
                                </div>
                            </div>
                        </div>
                        <button
                            onClick={capturePhoto}
                            className="mt-16 p-4 py-2 flex-none bg-green-1 text-white rounded-full size-12 relative"
                        >
                            <span className="absolute -inset-2 rounded-full border-2 border-green-3"></span>
                        </button>
                    </>
                ) : (
                    <div className="flex flex-col items-center">
                        <h2 className="text-md mb-3">پیش نمایش</h2>
                        <img
                            src={photo}
                            alt="Captured"
                            className="w-72 h-72 object-cover rounded-lg shadow-lg"
                        />
                        <div className="mt-4 grid grid-cols-2 gap-5 text-xs">
                            <button
                                onClick={retakePhoto}
                                className="px-4 py-2 bg-yellow-1 text-black rounded-full w-24"
                                disabled={isUploading}
                            >
                                بازگرفتن عکس
                            </button>
                            <button
                                onClick={handleUpload}
                                className={`px-4 py-2 bg-green-1 text-white rounded-full w-24 ${
                                    isUploading
                                        ? 'opacity-50 cursor-not-allowed'
                                        : ''
                                }`}
                                disabled={isUploading}
                            >
                                {isUploading
                                    ? 'درحال بارگزاری...'
                                    : 'بارگزاری عکس'}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default PhotoCapture
